import { getComponents, getComponent } from '../rest/index.tsx';
import type { SingleComponent } from '../types.tsx';
import { transformToOptions, transformToComponent } from './transformers.tsx';

type RequestComponents = (arg1: string[]) => Promise<SingleComponent[]>;

// @ts-expect-error - TS2559 - Type '(projectKeyOrId: any, ignore: any, filter: any) => Promise<SelectOption[]>' has no properties in common with type 'RequestInit'. | TS7006 - Parameter 'projectKeyOrId' implicitly has an 'any' type. | TS7006 - Parameter 'ignore' implicitly has an 'any' type. | TS7006 - Parameter 'filter' implicitly has an 'any' type.
export const requestComponentOptions: RequestInit = (projectKeyOrId, ignore, filter) =>
	getComponents(projectKeyOrId, filter, ignore).then((data) => transformToOptions(data, ignore));

export const requestComponentObjects: RequestComponents = (componentIds) =>
	Promise.allSettled(componentIds.map(getComponent)).then((results) =>
		results.flatMap((x) => (x.status === 'fulfilled' ? [transformToComponent(x.value)] : [])),
	);
